import { CloseIcon } from '@chakra-ui/icons';
import { Flex, FormControl, FormLabel, IconButton, Text } from '@chakra-ui/react';
import React, { useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import { SlCalender } from 'react-icons/sl';
import 'react-datepicker/dist/react-datepicker.css';

function DateTimePicker({ label, value, onChange, placeholder = "DD/MM/YYYY HH:mm", ...rest }) {
    const [error, setError] = useState(false);
    const datePickerRef = useRef(null);

    const handleDateChange = (date) => {
        if (date instanceof Date && !isNaN(date)) {
            setError(false);
            const roundedDate = roundToNearestTenMinutes(date);
            const formattedDate = formatDateToISO(roundedDate);

            onChange(formattedDate);
        } else {
            setError(true);
            onChange("");
        }
    };

    const roundToNearestTenMinutes = (date) => {
        const minutes = date.getMinutes();
        const roundedMinutes = Math.round(minutes / 10) * 10;
        date.setMinutes(roundedMinutes);
        return date;
    };

    const formatDateToISO = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    const clearDate = () => {
        onChange("");
    };

    const handleIconClick = () => {
        if (datePickerRef.current) {
            datePickerRef.current.setOpen(true);
        }
    };

    const isValidDate = (date) => {
        return date && !isNaN(new Date(date).getTime());
    };

    return (
        <FormControl {...rest}>
            {label && (
                <FormLabel
                    fontSize="lg"
                    fontWeight="bold"
                    mb="4px"
                >
                    {label}
                </FormLabel>
            )}
            <Flex position="relative">
                <DatePicker
                    ref={datePickerRef}
                    selected={isValidDate(value) ? new Date(value) : null}
                    onChange={handleDateChange}
                    placeholderText={placeholder}
                    showTimeSelect
                    timeIntervals={10}
                    timeFormat="HH:mm"
                    dateFormat="dd/MM/yyyy HH:mm"
                    onInputClick={handleIconClick}
                    shouldCloseOnSelect
                />
                {value && isValidDate(new Date(value)) ? (
                    <IconButton
                        icon={<CloseIcon />}
                        colorScheme="orange"
                        onClick={clearDate}
                        aria-label="Clear date"
                        position="absolute"
                        top="7px"
                        right="5px"
                        size="sm"
                        zIndex={1}
                    />
                ) : (
                    <IconButton
                        icon={<SlCalender />}
                        colorScheme="orange"
                        onClick={handleIconClick}
                        aria-label="Open date picker"
                        position="absolute"
                        right="5px"
                        top="7px"
                        size="sm"
                        zIndex={1}
                    />
                )}
                {/* {error && (
                    <Text color="red.500" fontSize="sm" mt="2">
                        Invalid date format. Please enter a valid date.
                    </Text>
                )} */}
            </Flex>
        </FormControl>
    );
}

export default DateTimePicker;
